// extracted by mini-css-extract-plugin
export var infoItem = "_sp-2";
export var title = "_sp-0";
export var value = "_sp-1";